export default "__VITE_ASSET__DseWXfrW__"